function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ArrowDown16x16 } from '../constants/Glyphs';
import PopoverButton from '../PopoverButton/PopoverButton';
import SelectOption from '../SelectOption';
import TscThemeName from '../constants/TscThemeName';
import styled, { keyframes } from 'styled-components';
import tscStyles from '../constants/TscStyles';
import guid from '../utils/guid';
import { getClassName } from '../utils/get-class-name';
import TscButtonType from '../constants/TscButtonType';
var animation = keyframes(["0%,75%{outline-color:rgba(0,114,207,.5)}100%{outline-color:transparent;outline-none;}"]);
var LabelWrapper = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "CustomSelectInput__LabelWrapper"
})(["width:", ";"], function (props) {
  return props.width || 'auto';
});
var Container = styled.div.withConfig({
  displayName: "CustomSelectInput__Container"
})(["display:flex;background-color:", ";border:1px solid ", ";width:", ";border-radius:", ";outline:2px solid transparent;outline-offset:2px;cursor:pointer;transition:background-color 150ms ease-out;&::-moz-focus-inner{border:0;}&:focus{outline-color:rgba(0,114,207,.5);animation:", " 4000ms  ease-out;animation-fill-mode:forwards;}&:focus:hover{outline-color:rgba(0,114,207,0);animation-play-state:paused;}&:hover{background:", ";fill:", ";text-decoration:none;}"], function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.ui.dusk.mediumDark : tscStyles.color.ui.dawn.lightMedium;
}, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.ui.dusk.dark : tscStyles.color.ui.dawn.medium;
}, function (props) {
  return props.width || 'auto';
}, tscStyles.border.radius.lg, animation, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.action.secondaryDusk : tscStyles.color.action.secondaryDawn;
}, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.text.light : tscStyles.color.text.mediumDark;
});
var PopoverButtonWrapper = styled.div.withConfig({
  displayName: "CustomSelectInput__PopoverButtonWrapper"
})(["display:flex;justify-content:center;align-items:center;padding:0.75rem;border-radius:0 ", " ", " 0;&:hover{background-color:", ";}"], tscStyles.border.radius.lg, tscStyles.border.radius.lg, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.ui.dusk.mediumDark : tscStyles.color.action.secondaryDawn;
});
var MenuWrapper = styled.div.withConfig({
  displayName: "CustomSelectInput__MenuWrapper"
})(["width:", "px;background-color:", ";box-shadow:1px 1px 12px ", ";position:absolute;left:calc(-", "px + 21px);top:2px;border-radius:", ";box-sizing:border-box;max-height:", ";overflow-y:auto;cursor:default;"], function (props) {
  return props.calcWidth;
}, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.ui.dusk.mediumDark : tscStyles.color.ui.dawn.light;
}, tscStyles.color.global.boxShadow, function (props) {
  return props.calcWidth;
}, tscStyles.border.radius.md, function (props) {
  return props.maxMenuHeight;
});
var Label = styled.label.withConfig({
  displayName: "CustomSelectInput__Label"
})(["display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:2rem;font-family:inherit;color:", ";font-size:.875rem;font-weight:600;width:", ";margin-bottom:-0.75rem;padding-bottom:0.25rem;"], function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.text.light : tscStyles.color.text.mediumDark;
}, function (props) {
  return props.width || 'auto';
});

var validateValue = function validateValue(options, newValue) {
  if (newValue) {
    var initialOption = options.find(function (o) {
      return o.value === newValue;
    });

    if (initialOption) {
      if (!initialOption.disabled) {
        return newValue;
      }

      console.error("New value of ".concat(newValue, " cannot correspond to a disabled option")); // eslint-disable-line no-console
    } else {
      console.error("New value of ".concat(newValue, " does not correspond to any option values")); // eslint-disable-line no-console
    }
  }

  var enabledOptions = options.filter(function (o) {
    return !o.disabled;
  });
  return enabledOptions[0].value;
};

var addEventListeners = function addEventListeners(mouseEventCallback, focusEventCallback) {
  window.addEventListener('mousedown', mouseEventCallback);
  window.addEventListener('focusout', focusEventCallback);
};

var removeEventListeners = function removeEventListeners(mouseEventCallback, focusEventCallback) {
  window.removeEventListener('mousedown', mouseEventCallback);
  window.removeEventListener('focusout', focusEventCallback);
};

var CustomSelectInput = function CustomSelectInput(_ref) {
  var _containerRef$current;

  var className = _ref.className,
      _ref$closeMenuOnClick = _ref.closeMenuOnClick,
      closeMenuOnClick = _ref$closeMenuOnClick === void 0 ? true : _ref$closeMenuOnClick,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$maxMenuHeight = _ref.maxMenuHeight,
      maxMenuHeight = _ref$maxMenuHeight === void 0 ? '15rem' : _ref$maxMenuHeight,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      testId = _ref.testId,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName,
      value = _ref.value,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showMenu = _React$useState2[0],
      setShowMenu = _React$useState2[1];

  var _React$useState3 = React.useState(function () {
    return validateValue(options, value);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      currentValue = _React$useState4[0],
      setCurrentValue = _React$useState4[1];

  var _React$useState5 = React.useState(-1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      focusIndex = _React$useState6[0],
      setFocusIndex = _React$useState6[1];

  var internalId = React.useMemo(function () {
    return "custom-select-input-".concat(guid.new());
  }, []);
  var popoverRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var menuRef = React.useRef(null);
  var currentOption = options.find(function (o) {
    return o.value === currentValue;
  });
  var calcWidth = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect().width;
  var enterKeyCode = 13;
  var spaceKeyCode = 32;
  var upKeyCode = 38;
  var downKeyCode = 40;
  var escapeKeyCode = 27;
  var internalMenuCloseRef = React.useRef(null);
  var internalMenuOpenRef = React.useRef(null);

  var setPopoverButtonAttribute = function setPopoverButtonAttribute(popoverButton) {
    popoverRef.current = popoverButton;

    if (popoverButton) {
      popoverButton.setAttribute('tabindex', '-1');
    }
  };

  var closeMenu = React.useCallback(function () {
    setFocusIndex(-1); // eslint-disable-next-line @typescript-eslint/no-use-before-define

    removeEventListeners(onMouseDown, onFocusOut);
    internalMenuCloseRef.current && internalMenuCloseRef.current();
    setShowMenu(false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var openMenu = React.useCallback(function () {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    addEventListeners(onMouseDown, onFocusOut);
    internalMenuOpenRef.current && internalMenuOpenRef.current();
    setShowMenu(true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onFocusOut = React.useCallback(function (e) {
    try {
      var _containerRef$current2;

      e.stopPropagation(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

      if (e.relatedTarget === null || e.relatedTarget && e.relatedTarget !== containerRef.current && !((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(e.relatedTarget))) {
        closeMenu();
      }
    } catch (err) {
      console.error("Error in onFocusOut: ".concat(err)); // eslint-disable-line  no-console, @typescript-eslint/restrict-template-expressions
    }
  }, [closeMenu]);
  var onMouseDown = React.useCallback(function (e) {
    try {
      var _containerRef$current3;

      if (containerRef.current === e.target || (_containerRef$current3 = containerRef.current) !== null && _containerRef$current3 !== void 0 && _containerRef$current3.contains(e.target)) {
        e.preventDefault();
      } else {
        closeMenu();
      }
    } catch (err) {
      console.error("Error in onMouseDown: ".concat(err)); // eslint-disable-line no-console, @typescript-eslint/restrict-template-expressions
    }
  }, [closeMenu]);
  React.useEffect(function () {
    setCurrentValue(validateValue(options, value));
  }, [options, value]);
  React.useEffect(function () {
    window.addEventListener('resize', closeMenu);
    return function () {
      removeEventListeners(onMouseDown, onFocusOut);
      window.removeEventListener('resize', closeMenu);
    };
  }, [closeMenu, onMouseDown, onFocusOut]); // used as KeyboardEvent or MouseEvent handler so the generic specification applies

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();

    if (showMenu) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  var selectNextOption = function selectNextOption() {
    var enabledOptions = options.filter(function (o) {
      return !o.disabled;
    });
    var currentIndex = enabledOptions.findIndex(function (o) {
      return o.value === currentValue;
    });
    var nextIndex = currentIndex + 1;

    if (nextIndex < enabledOptions.length) {
      setCurrentValue(enabledOptions[nextIndex].value);
      onChange && onChange(enabledOptions[nextIndex].value);
    }
  };

  var focusNextOption = function focusNextOption() {
    var enabledOptions = options.filter(function (o) {
      return !o.disabled;
    });
    var newFocusIndex = focusIndex + 1;

    if (newFocusIndex < enabledOptions.length) {
      var _menuRef$current;

      setFocusIndex(newFocusIndex);
      var nextIndex = options.findIndex(function (o) {
        return o.value === enabledOptions[newFocusIndex].value;
      });
      (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.children[nextIndex].focus();
    }
  };

  var selectPrevOption = function selectPrevOption() {
    var enabledOptions = options.filter(function (o) {
      return !o.disabled;
    });
    var currentIndex = enabledOptions.findIndex(function (o) {
      return o.value === currentValue;
    });
    var nextIndex = currentIndex - 1;

    if (nextIndex >= 0) {
      setCurrentValue(enabledOptions[nextIndex].value);
      onChange && onChange(enabledOptions[nextIndex].value);
    }
  };

  var focusPrevOption = function focusPrevOption() {
    var enabledOptions = options.filter(function (o) {
      return !o.disabled;
    });
    var newFocusIndex = focusIndex - 1;

    if (newFocusIndex >= 0) {
      var _menuRef$current2;

      setFocusIndex(newFocusIndex);
      var nextIndex = options.findIndex(function (o) {
        return o.value === enabledOptions[newFocusIndex].value;
      });
      (_menuRef$current2 = menuRef.current) === null || _menuRef$current2 === void 0 ? void 0 : _menuRef$current2.children[nextIndex].focus();
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (!e.shiftKey && (e.keyCode === enterKeyCode || e.keyCode === spaceKeyCode)) {
      handleClick(e);
    } else if (!e.shiftKey && e.keyCode === upKeyCode) {
      e.preventDefault(); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      showMenu ? focusPrevOption() : selectPrevOption();
    } else if (!e.shiftKey && e.keyCode === downKeyCode) {
      e.preventDefault(); // eslint-disable-next-line @typescript-eslint/no-unused-expressions

      showMenu ? focusNextOption() : selectNextOption();
    } else if (!e.shiftKey && e.keyCode === escapeKeyCode) {
      e.preventDefault();
      showMenu && closeMenu();
    }
  }; // used as KeyboardEvent or MouseEvent handler so the generic specification applies


  var handleOptionClick = function handleOptionClick(e, newValue) {
    e.stopPropagation();
    e.preventDefault();
    setCurrentValue(newValue);
    onChange && onChange(newValue);
    closeMenuOnClick && closeMenu();
  };

  var handleMenuKeyDown = function handleMenuKeyDown(e) {
    if (!e.shiftKey && (e.keyCode === enterKeyCode || e.keyCode === spaceKeyCode)) {
      var newValue = e.target.getAttribute('value');
      handleOptionClick(e, newValue || '');
    }
  };

  var controlProps = {
    themeName: themeName,
    width: width,
    maxMenuHeight: maxMenuHeight
  };

  var menu = _jsx(MenuWrapper, _objectSpread(_objectSpread({
    className: getClassName(className, 'menu-wrapper')
  }, controlProps), {}, {
    calcWidth: calcWidth !== null && calcWidth !== void 0 ? calcWidth : 0,
    onKeyDown: handleMenuKeyDown,
    ref: menuRef,
    role: "listbox",
    "aria-label": label,
    children: options.map(function (o) {
      return _jsx(SelectOption, {
        className: className,
        themeName: themeName,
        text: o.label,
        subtext: o.subtext,
        badgeText: o.badgeText,
        glyph: o.glyph,
        value: o.value,
        disabled: o.disabled,
        onClick: handleOptionClick
      }, o.label);
    })
  }));

  var popover = _jsx(PopoverButton, {
    className: className,
    buttonText: "",
    buttonTitle: label,
    buttonGlyph: _jsx(ArrowDown16x16, {}),
    popoverMenu: menu,
    buttonType: TscButtonType.floating,
    themeName: themeName,
    disableEventListeners: true,
    useMobileMenu: false,
    style: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    buttonRef: setPopoverButtonAttribute,
    menuHideRef: internalMenuCloseRef,
    menuShowRef: internalMenuOpenRef
  });

  return _jsxs(LabelWrapper, _objectSpread(_objectSpread({
    className: getClassName(className, null, 'label-wrapper')
  }, controlProps), {}, {
    testId: testId,
    children: [!!label.length && _jsx(Label, _objectSpread(_objectSpread({
      htmlFor: internalId
    }, controlProps), {}, {
      children: label
    })), _jsxs(Container, _objectSpread(_objectSpread({
      className: getClassName(className, 'container')
    }, controlProps), {}, {
      onClick: handleClick,
      ref: containerRef,
      tabIndex: 0,
      onKeyDown: handleKeyDown,
      id: internalId,
      children: [_jsx(SelectOption, {
        className: className,
        themeName: themeName,
        text: (currentOption === null || currentOption === void 0 ? void 0 : currentOption.label) || '',
        subtext: currentOption === null || currentOption === void 0 ? void 0 : currentOption.subtext,
        badgeText: currentOption === null || currentOption === void 0 ? void 0 : currentOption.badgeText,
        glyph: currentOption === null || currentOption === void 0 ? void 0 : currentOption.glyph,
        value: currentOption === null || currentOption === void 0 ? void 0 : currentOption.value,
        disabled: currentOption === null || currentOption === void 0 ? void 0 : currentOption.disabled,
        isMenuItem: false
      }, currentOption === null || currentOption === void 0 ? void 0 : currentOption.label), _jsx(PopoverButtonWrapper, _objectSpread(_objectSpread({
        className: getClassName(className, 'popover-button-wrapper')
      }, controlProps), {}, {
        children: popover
      }))]
    }))]
  }));
};

var CustomSelectInputTest = {
  Container: Container,
  MenuWrapper: MenuWrapper,
  Label: Label
};
export { CustomSelectInput, CustomSelectInputTest };
export default CustomSelectInput;